var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import classNames from "classnames";
import { Link, Hint } from "@riseart/common";
import { CloseIcon, LikeIcon } from "@riseart/icons";
import { filterOptionCls, filterOptionLabelCls, filterOptionActiveCls, filterOptionDisabledCls } from "./Option.less";
var DEFAULT_TAG = "li";
var FilterOption = /* @__PURE__ */ __name(function FilterOption2(_ref) {
  var _ref$tag = _ref.tag, Tag = _ref$tag === void 0 ? DEFAULT_TAG : _ref$tag, className = _ref.className, url = _ref.url, isNoFollow = _ref.isNoFollow, value = _ref.value, label = _ref.label, hintLabel = _ref.hintLabel, title = _ref.title, selected = _ref.selected, disabled = _ref.disabled, _ref$showHint = _ref.showHint, showHint = _ref$showHint === void 0 ? false : _ref$showHint, handleClick = _ref.handleClick, dimension = _ref.dimension;
  var filterLinkComponent = disabled ? /* @__PURE__ */ React.createElement("span", {
    className: disabled ? filterOptionDisabledCls : null
  }, label || value) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Link, _extends({
    type: "light",
    to: url
  }, isNoFollow ? {
    rel: "nofollow"
  } : null, {
    title
  }, isNoFollow ? {
    obfuscate: true,
    obflinkProps: {
      stopPropagation: true
    }
  } : null, {
    onClick: /* @__PURE__ */ __name(function onClick(e) {
      e.preventDefault();
      handleClick(dimension, {
        url,
        value,
        selected
      });
    }, "onClick")
  }), /* @__PURE__ */ React.createElement("span", {
    className: classNames(filterOptionLabelCls, selected && filterOptionActiveCls)
  }, label || value), /* @__PURE__ */ React.createElement(LikeIcon, null)), selected ? /* @__PURE__ */ React.createElement(CloseIcon, null) : null);
  return showHint ? /* @__PURE__ */ React.createElement(Hint, {
    wrapperTag: Tag,
    wrapperClassName: classNames(filterOptionCls, className, value),
    text: hintLabel || label
  }, filterLinkComponent) : /* @__PURE__ */ React.createElement(Tag, {
    className: classNames(filterOptionCls, className, value)
  }, filterLinkComponent);
}, "FilterOption");
export {
  FilterOption
};
